<template>
  <div class="credit-allocation-mana">
    <a-card>
      <div class="text-right">
        <!-- 批量上传modal -->
        <batch-upload-modal
          ref="batchUploadModal"
          @ok="handleModalOk"
          @download="_downloadTemp"
        />
      </div>

      <a-row style="margin-bottom: 10px">
        <a-col :span="12">当前授信企业：{{ sourceData.parentName }}</a-col>
        <a-col :span="12">
          信用限额敞口：{{ creditExposure | formatAmount }}
        </a-col>
      </a-row>

      <a-divider />

      <card-edit
        ref="cardEdit"
        :schema="CREDIT_ALLOCATION_SCHEMA"
        :source-data="sourceData"
        :gutter="gutter"
      >
        <template v-slot:parent="slotProps">
          <a-auto-complete
            v-decorator="$decorator(slotProps.item.key, '请选择授信企业')"
            placeholder="请输入"
            @select="handleSelect"
            @search="handleSearch"
            :allow-clear="true"
          >
            <template slot="dataSource">
              <a-select-option
                v-for="item in parentList"
                :key="item.code"
                :value="JSON.stringify(item)"
              >
                {{ item.name }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </template>
      </card-edit>

      <a-row>
        <a-col style="text-align:center;">
          <a-form-model-item>
            <a-button type="primary" @click="handleSubmit" :loading="loading">
              提 交
            </a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { CardEdit } from 'lxfintech-fe'
import { ERR_OK } from 'config/index'
import { CREDIT_ALLOCATION_SCHEMA } from './schema'
import {
  getCustomerList,
  getAllocateOverview,
  doAllocate,
  uploadBatchAllocate,
  downloadAllocateTemp,
} from './api'
import BatchUploadModal from 'components/BatchUploadModal.vue'

export default {
  name: 'credit-allocation-mana',
  data() {
    return {
      CREDIT_ALLOCATION_SCHEMA,
      sourceData: {
        parentName: '',
        childCode: '',
        amount: '',
      },
      gutter: { xs: 8, sm: 16, md: 24, lg: 24 },
      parentCode: '',
      creditExposure: 0, //信用限额敞口
      parentList: [], // 母公司列表
      loading: false,
    }
  },
  methods: {
    handleSelect(value) {
      const selectedValue = JSON.parse(value)
      const parentCode = selectedValue.code
      const parentName = selectedValue.name
      this.getChildList(parentCode)
      this.$refs.cardEdit.setFormFieldsValue('childCode', '')
      this.$refs.cardEdit.setFormFieldsValue('parentName', parentName)
      this.sourceData.parentName = parentName
      this.parentCode = parentCode
      this.parentList = []
    },
    async getChildList(parentCode) {
      try {
        const {
          data: { creditExposure, children },
        } = await getAllocateOverview({ parentCode })
        this.creditExposure = creditExposure
        this.CREDIT_ALLOCATION_SCHEMA.childCode.optionList = children
      } catch (error) {
        console.error(error)
      }
    },
    async handleSearch(value) {
      if (!value.trim()) {
        return
      }
      try {
        const { data } = await getCustomerList(value)
        this.parentList = data
      } catch (error) {
        console.error(error)
      }
    },
    async handleSubmit() {
      const $cardEdit = this.$refs.cardEdit
      try {
        const values = await $cardEdit.handleSubmit()
        const passed = !!values
        if (passed) {
          // 校验通过
          const params = {
            parentCode: this.parentCode,
            childCode: values.childCode,
            amount: values.amount,
          }
          // 提交
          this._doAllocate(params)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async _doAllocate(params) {
      if (this.loading) {
        return
      }
      try {
        this.loading = true
        const { code, message } = await doAllocate(params)
        if (code == ERR_OK) {
          this.$notification.success({
            message: '提示',
            description: message,
          })
          this.$refs.cardEdit.handleReset()
        } else {
          this.$notification.error({
            message: '提示',
            description: message,
          })
        }
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    // 确定上传
    async handleModalOk(fileList) {
      if (fileList && fileList.length) {
        try {
          const { code, message } = await uploadBatchAllocate({
            file: fileList,
          })
          if (code === ERR_OK) {
            this.$notification.success({
              message: '提示',
              description: message || '成功',
            })
            this.handleModalCancel()
          } else {
            this.$notification.error({
              message: '提示',
              description: message || '失败',
            })
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    handleModalCancel() {
      this.$refs.batchUploadModal.handleCancel()
    },
    _downloadTemp() {
      downloadAllocateTemp()
    },
  },
  components: {
    CardEdit,
    BatchUploadModal,
  },
}
</script>

<style></style>
